import OverallStatisticsView from '@/modules/overallStatistics/view/OverallStatisticsView.vue';

// Dedicated route for the future overall statistics implementation.
export const OverallStatisticsRoutes = [
  {
    path: '/statistics/overall',
    name: 'OverallStatistics',
    component: OverallStatisticsView,
  }
];